import type { _brandedTag } from "@@/utilities/branded";
import { assertNever } from "./assert-never";
import type { OrderGroupId } from "./order-groups/order-group-id";
import { isOrderGroupId } from "./order-groups/order-group-id";
import type { OrderId } from "./orders/order-id";
import { isOrderId } from "./orders/order-id";
import type { ProviderId } from "./providers/provider-id";
import { isProviderId } from "./providers/provider-id";
import type { TicketId } from "./tickets/ticket-id";
import { isTicketId } from "./tickets/ticket-id";
import type { CustomerId } from "./users/customer-id";
import { isCustomerId } from "./users/customer-id";
import type { UserId } from "./users/user-id";
import { isUserId } from "./users/user-id";

type Target =
    | UserId
    | ProviderId
    | OrderId
    | OrderGroupId
    | CustomerId
    | TicketId;

function targetFilter(
    byType: ProviderId[typeof _brandedTag],
    targets: Target[],
): ProviderId[];
function targetFilter(
    byType: UserId[typeof _brandedTag],
    targets: Target[],
): UserId[];
function targetFilter(
    byType: OrderId[typeof _brandedTag],
    targets: Target[],
): OrderId[];
function targetFilter(
    byType: OrderGroupId[typeof _brandedTag],
    targets: Target[],
): OrderGroupId[];
function targetFilter(
    byType: Target[typeof _brandedTag],
    targets: Target[],
): Target[] {
    switch (byType) {
        case "ProviderId":
            return targets.filter(isProviderId);
        case "OrderGroupId":
            return targets.filter(isOrderGroupId);
        case "OrderId":
            return targets.filter(isOrderId);
        case "UserId":
            return targets.filter(isUserId);
        case "CustomerId":
            return targets.filter(isCustomerId);
        case "TicketId":
            return targets.filter(isTicketId);
        default:
            assertNever(byType);
    }
}

export { targetFilter };
export type { Target };
